var render = function render(_c,_vm){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":_vm.props.fill,"width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }